import React from "react";
import { Button } from "@chakra-ui/react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { BsPlusLg } from "react-icons/bs";
import RiskReviewPageShell from "../components/common/RiskReviewPageShell";
import RiskReviewPanel from "../components/common/RiskReviewPanel";
import RiskReviewRequestFilters from "../components/requests/RiskReviewRequestFilters";
import RiskReviewRequestTable from "../components/requests/RiskReviewRequestTable";
import RiskReviewEmptyState from "../components/common/RiskReviewEmptyState";
import RiskReviewErrorState from "../components/common/RiskReviewErrorState";
import RiskReviewLoadingState from "../components/common/RiskReviewLoadingState";
import { useRiskReviewRequests } from "../hooks/useRiskReviewRequests";

const readFilters = (params) => ({
  search: params.get("search") || "",
  status: params.get("status") || "",
  requestType: params.get("requestType") || "",
  businessUnit: params.get("businessUnit") || "",
});

const RiskReviewRequestsPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = readFilters(searchParams);
  const query = useRiskReviewRequests(filters);
  const requests = Array.isArray(query.data) ? query.data : query.data?.items || [];
  const hasFilters = Object.values(filters).some(Boolean);

  const updateFilters = (next) => {
    const params = new URLSearchParams();
    Object.entries(next).forEach(([key, value]) => {
      if (value) params.set(key, value);
    });
    setSearchParams(params);
  };

  return (
    <RiskReviewPageShell
      title="Risk Review Requests"
      description="Search, filter, and open active review requests."
      actions={
        <Button as={RouterLink} to="/risk-review/requests/new" size="sm" colorScheme="blue" leftIcon={<BsPlusLg />}>
          Create Risk Review
        </Button>
      }
    >
      <RiskReviewPanel>
        <RiskReviewRequestFilters filters={filters} onChange={updateFilters} onReset={() => setSearchParams({})} />
      </RiskReviewPanel>
      {query.isLoading ? <RiskReviewLoadingState rows={8} /> : null}
      {query.isError ? <RiskReviewErrorState error={query.error} onRetry={query.refetch} /> : null}
      {query.isSuccess && requests.length ? <RiskReviewRequestTable requests={requests} /> : null}
      {query.isSuccess && !requests.length ? (
        <RiskReviewEmptyState
          title="No Risk Reviews found"
          message={hasFilters ? "No requests match the current filters." : "No Risk Reviews have been created yet."}
          actionLabel={!hasFilters ? "Create Risk Review" : undefined}
          onAction={() => navigate("/risk-review/requests/new")}
        />
      ) : null}
    </RiskReviewPageShell>
  );
};

export default RiskReviewRequestsPage;
